seedWebApp.controller('StagesAlternativeApprovalController', ['$scope', '$rootScope', '$uibModal', 'ToastService', 'TranslationService', 'HelpdeskService',
    function ($scope, $rootScope, $uibModal, ToastService, TranslationService, HelpdeskService) {

        $scope.columns = [
            { name: 'ApprovalUserID', display: $scope.translation.ApprovalUser, orderBy: 'desc', editable: false, width: 30 },
            { name: 'AlternativeApprovalUserID', display: $scope.translation.AlternativeApprovalUser, editable: false, width: 30 },
            { name: 'DateStart', display: $scope.translation.StartDate, dataType: 'date', format: $scope.translation.DatePickerFormat, editable: false, width: 30 },
            { name: 'DateEnd', display: $scope.translation.EndDate, dataType: 'date', format: $scope.translation.DatePickerFormat, editable: false, width: 30 },
            { name: 'IsActive', display: $scope.translation.Active, dataType: 'boolean', editable: false, width: 10 },
        ];

        $scope.prefs = {
            name: 'AltApprovalUserGrid',
            sortByCol: null,
            canAdd: true,
            canEdit: true,
            canDelete: false,
            parentFilter: false, //showDisabled
        };

        $scope.loadService = HelpdeskService.searchAlternativeApprovals;
        $scope.resetService = HelpdeskService.resetCache;

        $scope.prefs.sortByCol = $scope.columns[0];
        $scope.prefs.sortByCol.orderReverse = false;
        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.doInsert = function () {
            docTypeModalResult(openModalStage());
        };

        $scope.prefs.customEdit = function (item) {
            docTypeModalResult(openModalStage(item));
        };

        function openModalStage(item) {
            return $uibModal.open({
                templateUrl: './SPA/Settings/Stages/stageAlternativeApprovalModal.html' + seedWebApp.buildVersion,
                controller: 'StageAlternativeApprovalModalCtrl as ctrl',
                size: 'lg',
                resolve: {
                    item: function () {
                        return item ? item : {};
                    },
                    translation: function () {
                        return $scope.translation;
                    },
                    isEdit: function () {
                        return item ? true : false;
                    }
                }
            });
        }

        function docTypeModalResult(modalInstance) {
            modalInstance.result.then(function () {
                $scope.doRefresh();
            });
        }
    }
]);

